module.exports = __webpack_public_path__ + "media/images/emblems/Saint_Imier-coat_of_arms-c9cc6bb64e9361d266e75814d14e35d1.svg";